var wFlag=true
if(window.innerWidth<750){
    wFlag=false
    $('.box3_video').attr({
        autoplay: true,
        loop: true
    });
}

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<21;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/ULTRALOCK_box7_${i}.avif?v=1760511088`;
    }
};
preloadImages()

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

$(()=>{
    ScrollTrigger.create({
        trigger:'.box2_item',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top',
            end:'+=60%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box3_mask',{scale:2.5,opacity:0})
                .from('.box3_item',{opacity:0,y:'2rem'})
        })

        var $video = $('.box3_video');
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top+=60% top',
            end:'+=80%',
            scrub:true,
            onUpdate:(self)=>{
                //$video[0].duration
                $video[0].currentTime = self.progress * 4.64;
            },
            // markers:true,
        })

        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top',
            end:'+=160%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box3_mask',
            start:'top bottom-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            // markers:true,
            animation:gsap.timeline()
                .from('.box3_mask',{scale:2.5,opacity:0})
        })
    }

    $('.box5_item div').hover(function(){
        $(this).addClass('box5_active').siblings().removeClass('box5_active')
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box_border',
            start:'top center',
            end:'+=60%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box5',{opacity:0,pointerEvents:'none'})
                .from('.box5_title',{scale:5,opacity:0},'-=50%')
                .from('.box5_item',{y:'2rem',opacity:0},'-=50%')
        })

        ScrollTrigger.create({
            trigger:'.box_border',
            start:'top top+=5%',
            end:'+=50%',
            pin:true,
        })
    }else{
        showUp('.box5_title')
    }

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .to('.box6_icon1',{x:0,y:0,duration:0.5})
    })

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box6_rMask',{scale:0,duration:0.5})
    })

    ScrollTrigger.create({
        trigger:'.box6',
        start:'top top+=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .to('.box6_icon2',{x:0,y:0,duration:0.5})
    })
    
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box_border2',
            start:'top top+=5%',
            end:'+=80%',
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 19);
                $('.box7_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/ULTRALOCK_box7_${index+1}.avif?v=1760511088`) 
            },
            animation:gsap.timeline()
                .to('.box7_text1',{x:0,y:0})
                .to('.box7_text2',{x:0,y:0},'<')
        })
        
        ScrollTrigger.create({
            trigger:'.box_border2',
            start:'top+=100% top+=5%',
            end:'+=100%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box7_img',{opacity:0})
                .to('.box7_text',{opacity:0},'<')
                .from('.box8_items .box8_item:first-child',{scale:0,duration:0.2},'-=50%')
                .from('.box8_items .box8_item:last-child',{opacity:0})
                .from('.box8_title',{opacity:0},'<')
                .to('.box8_items',{x:'-55%',duration:0.5})
        })
        
        ScrollTrigger.create({
            trigger:'.box_border2',
            start:'top top+=5%',
            end:'+=220%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top center+=20%',
            end:'+=60%',
            scrub:1,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 19);
                $('.box7_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/ULTRALOCK_box7_${index+1}.avif?v=1760511088`) 
            },
            animation:gsap.timeline()
                .to('.box7_text1',{x:0,y:0})
                .to('.box7_text2',{x:0,y:0},'<')
        })
        
        showUp('.box8_title')
        showUp('.box8_items .box8_item:first-child')
        ScrollTrigger.create({
            trigger:'.box8',
            start:'top top+=5%',
            end:'+=60%',
            pin:true,
            scrub:1,
            animation:gsap.timeline()
                .to('.box8_items',{x:'-50%'})
        })
    }

    ScrollTrigger.create({
        trigger:'.box9',
        start:wFlag?'top top+=40%':'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // scrub:1,
        animation:gsap.timeline()
            .from('.box9_bg',{clipPath:wFlag?'circle(100% at 48% 100%)':'circle(115% at 50% 100%)'})
            .from('.box9_img1',{rotate:'0deg'})
            .from('.box9_text1',{y:'2rem',opacity:0})
            .from('.box9_text',{y:'2rem',opacity:0},'<')
    })

    showUp('.box10_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box10_item',
            start:'top bottom-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            // markers:true,
            animation:gsap.timeline()
                .from('.box10_item',{opacity:0,y:'2rem',stagger:0.2})
        })
    }else{
        new Swiper('.box10Swiper', {
            slidesPerView: 1.25,
            centeredSlides: true,
            autoplay:true,
            loop:true
        })
    }

    showUp('.box11_title')

    showUp('.specs_content')

    showUp('.pi_item')
})

//flavorsSwiper
new Swiper('.flavorsSwiper', {
    slidesPerView:wFlag?5:1.5,
    centeredSlides: true,
    autoplay:true,
    navigation: {
        nextEl: '.flavorsSwiper-button-next',
        prevEl: '.flavorsSwiper-button-prev',
    }
})

showUp('.flavors_title')